var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevxLogo = function SvgDevxLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "devx-logo_svg__Layer_2",
    x: 0,
    y: 0,
    viewBox: "0 0 553.3 161.7"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".devx-logo_svg__st0{fill:#231f20}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7 71.7h48.6c11.1 0 19.6.5 23.6 4.6 3.6 3.8 3.7 11.5 3.7 23.6 0 12.3.2 18.1-4.3 22-3.7 3.2-11.7 5-21.6 5h-50zm47 45.1c4.7 0 8-.6 10.3-1.8 3.4-1.7 4.8-6 4.8-14.5 0-15.3-2.5-18.4-15.2-18.4H55.2v34.6h33.5zM131.4 81.5v-9.8h66.4v9.7zM181 90v8.7s-33.1-1.3-33.7 0-.4 17.4 0 18.5c.3.9 43.3.7 51-1v10.7h-66.9V90zM302.6 71.7h25.2l20 15.1c-5.5 3.5-9.7 6.3-15.3 9.3l-29.8-21.8zM350.6 110c7.9-6.1 10.5-8.3 13.8-11l36.7 27.7h-29.3zM274.6 71.7h20.3l-23.8 30.9c-5.6-2.1-10-5.6-13.5-8.4zM257.8 122l-4.7 5.2-18.6-19.7c8.7 6.5 18.1 13.9 23.3 14.5",
    className: "devx-logo_svg__st0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "devx-logo_svg__SVGID_1_",
    x1: 41.516,
    x2: 515.177,
    y1: 76.251,
    y2: 76.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1788c3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#1b84c1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    style: {
      stopColor: "#2877ba"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#3c61ae"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    style: {
      stopColor: "#59439d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    style: {
      stopColor: "#6f2c91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    style: {
      stopColor: "#822982"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    style: {
      stopColor: "#a32569"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    style: {
      stopColor: "#be2154"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    style: {
      stopColor: "#d31f43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    style: {
      stopColor: "#e21d38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    style: {
      stopColor: "#ea1b31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    style: {
      stopColor: "#ed1b2f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.8 126.4c2-21.6 38.6-86.8 91.6-87.5 76.1-.9 91.8 88.2 156.6 89 37.8.5 57.9-22.6 87.9-42s62.9-37.6 137.3-42.2c-49.3-4.9-90.9 6.7-129 23.5s-53.4 43.1-96.5 43.6c-50.4-2.2-73.5-80.9-144.7-86.1S37.8 102.9 41.8 126.4",
    style: {
      fill: "url(#devx-logo_svg__SVGID_1_)"
    }
  }));
};
export default SvgDevxLogo;